import styled from 'styled-components'

import { ReactComponent as InfoGreyIcon } from 'resources/images/icons/info-grey.svg'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
`

export const Tag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ color }) => color};
  padding: 5px 10px;
  border-radius: 20px;
`

export const Icon = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 5px;
`

export const Description = styled.div`
  font-family: 'EBGaramond', serif;
  color: ${({ color }) => color};
  font-size: 14px;
  padding-bottom: 0.826px;
`

export const InfoButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
`

export const InfoIcon = styled(InfoGreyIcon)`
  width: 18px;
  height: 18px;
  path {
    fill: ${({ color }) => color};
  }
`
